import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import moment from "moment";


const styles = StyleSheet.create({
    termsContainer: {
        width: '97%',
        margin: '15 auto',
        paddingLeft: 5,
        paddingRight: 5,
        display: 'flex',
        flexDirection: 'row',
        border: '1px solid black',
    },
    termsContainerFirmas: {
        width: '97%',
        margin: '15 auto',
        paddingBottom: 20,
        display: 'flex',
        flexDirection: 'row',
    },
    termsColumn1: {
        display: 'flex',
        minWidth: '50%',
        maxWidth: '50%',
        paddingRight: '5px',
        fontSize: '5.5',
        textAlign: 'justify',
        paddingTop: 5,
        paddingBottom: 5,
    },
    termsColumn2: {
        display: 'flex',
        minWidth: '50%',
        maxWidth: '50%',
        paddingLeft: '5px',
        fontSize: '5.5',
        textAlign: 'justify',
        paddingTop: 5,
        paddingBottom: 5,
    },
    subTerm: {
        paddingLeft: '17.5px',
    },
    descriptionTerm: {
        paddingLeft: '10px',
    },
    padTop: {
        paddingTop: '10px',
    },
    signature: {
        alignItems: 'center',
    },
});
const tab = "               ";


const FooterOC = ({ header, _user, view }) => {

    return (
        <>
            <View style={styles.termsContainer}>
                <View style={styles.termsColumn1}>
                    <Text style={[{ textDecoration: 'underline' }]}>PARA REGISTRO DE FACTURAS </Text>
                    {/* <Text> </Text> */}
                    <Text>1.- Toda factura debe ser enviada por el portal de proveedores (https://saprov.llamagas.nubeprivada.biz/), se podrá ingresar con el usuario y contraseña del proveedor. Para poder registrar la factura deberá contar con su nota de ingreso y/o conformidad de servicio en el sistema.</Text>
                    <Text>2.- En el caso de presentar inconvenientes en el portal para el registro de factura este debe ser enviado al correo contabilidad@grupollamagas.pe todos los documentos (OC, Guía remisión, nota de ingreso, factura pdf y xml) (OS, Conformidad, factura pdf y xml).</Text>
                    <Text>3.- Para el punto 1 y punto 2 considerar como fecha límite el 28 del mes correspondiente a la entrega del bien o ejecución del servicio.</Text>
                    <Text>4.- La fecha de pago se contabiliza a partir del registro de factura en el portal de proveedores o registro contable.</Text>
                </View>

                <View style={[styles.termsColumn2, { borderLeft: '1px solid black' }]}>
                    <Text style={[{ textDecoration: 'underline' }]}>PARA ENTREGA DE BIENES</Text>
                    {/* <Text> </Text> */}
                    <Text>1.- El horario de recepción de bienes en los almacenes de diferentes plantas, son: </Text>
                    <Text style={styles.descriptionTerm}>- Planta Arequipa, Cusco, Pisco, Piura, Trujillo, Naranjal y Lurín, se atenderán los días lunes y miércoles de 09:00 a 12:00 y 14:00 a 15:00.</Text>
                    <Text style={styles.descriptionTerm}>- En el caso de Planta Naranjal, Pisco y Lurín; se atenderá tambien los viernes, en mismo horario</Text>
                    <Text>2.- En caso de que los bienes presenten defectos u alguna observación, no será recepcionado. </Text>
                    <Text> </Text>

                    <Text style={[{ textDecoration: 'underline' }]}>INFORMACIÓN IMPORTANTE</Text>
                    {/* <Text> </Text> */}
                    <Text>Todo proveedor y contratista deberá cumplir y mantenerse alineado con los Procedimientos de Ingreso a Plantas y el Procedimiento de Gestión de Contratistas establecidos por la empresa, así como con los requisitos de SMA-SIG aplicables, antes y durante la ejecución de los servicios.</Text>
                </View>
            </View>
            <View style={[styles.termsContainerFirmas, styles.padTop]}>
                <View style={[styles.termsColumn1, styles.signature, { fontSize: '7' }]}>
                    <Text >_________________________________ </Text>
                    <Text>Preparado por</Text>
                    <Text>{header?.Analista || ''}</Text>
                    <Text>{header?.Gestor || header?.SlpName || ''}</Text>
                    <Text>{header?.OPQTDocDate ? moment(header?.OPQTDocDate).format('DD/MM/YYYY') : ''}</Text>
                </View>

                <View style={[styles.termsColumn2, styles.signature, { fontSize: '7' }]}>
                    <Text >_________________________________ </Text>
                    <Text>Aprobado por</Text>
                    <Text>{header?.DocEntryBorrador ? (header?.ApprovedBy || '') : ''}</Text>
                    <Text>{header?.DocDate ? moment(header?.DocDate)?.format('DD/MM/YYYY') : ''}</Text>
                </View>
            </View>
        </>

    );
};

export default FooterOC